var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          ref: "modalManageVisits",
          attrs: {
            "hide-footer": "",
            size: "lg",
            id: "modalManageVisits",
            title: "Visitas entidades"
          },
          on: {
            hidden: function($event) {
              _vm.$parent.closeManageVisitsEntities()
            }
          }
        },
        [
          _c(
            "b-form",
            [
              _c(
                "b-row",
                [
                  _c("b-col", { attrs: { cols: 12 } }, [
                    _c(
                      "div",
                      [
                        _c(
                          "b-form-checkbox",
                          {
                            attrs: {
                              id: "checkbox1",
                              value: true,
                              "unchecked-value": false
                            },
                            model: {
                              value: _vm.inputs.showMyVisits,
                              callback: function($$v) {
                                _vm.$set(_vm.inputs, "showMyVisits", $$v)
                              },
                              expression: "inputs.showMyVisits"
                            }
                          },
                          [
                            _vm._v(
                              "\n          Ver sólo mis visitas\n          "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mt-3" },
                [
                  _c(
                    "b-col",
                    { attrs: { cols: 6 } },
                    [
                      _vm._v(
                        "\n                  Entidades\n                  "
                      ),
                      _c("multiselect", {
                        attrs: {
                          placeholder: "Todas",
                          "deselect-label": "Click o enter para deseleccionar",
                          "select-label": "Click o enter para seleccionar",
                          options: _vm.inputs.entity.options,
                          multiple: false,
                          "close-on-select": true,
                          "clear-on-select": true,
                          "preserve-search": true,
                          label: "name",
                          "track-by": "value",
                          "preselect-first": true
                        },
                        model: {
                          value: _vm.inputs.entity.value,
                          callback: function($$v) {
                            _vm.$set(_vm.inputs.entity, "value", $$v)
                          },
                          expression: "inputs.entity.value"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: 2 } },
                    [
                      _vm._v("\n                 \n                "),
                      _c(
                        "b-button",
                        {
                          attrs: {
                            size: "lg",
                            block: true,
                            variant: "primary"
                          },
                          on: { click: _vm.submitFilters }
                        },
                        [
                          _c("i", { staticClass: "p-0 fa fa-search" }),
                          _vm._v("  Buscar\n                ")
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: 2 } },
                    [
                      _vm._v("\n                 \n                "),
                      _c(
                        "b-button",
                        {
                          attrs: {
                            size: "lg",
                            block: true,
                            variant: "default"
                          },
                          on: { click: _vm.exportExcel }
                        },
                        [
                          _c("i", { staticClass: "p-0 fa fa-download" }),
                          _vm._v("  Exportar\n                  ")
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: 2 } },
                    [
                      _vm._v("\n                 \n                "),
                      _c(
                        "b-button",
                        {
                          attrs: {
                            size: "lg",
                            block: true,
                            variant: "secondary"
                          },
                          on: {
                            click: function($event) {
                              _vm.showManageVisitsEntitiesResultsNewVisitPopup = true
                            }
                          }
                        },
                        [
                          _c("i", { staticClass: "p-0 fa fa-plus" }),
                          _vm._v("  Nueva visita\n                  ")
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              !_vm.showManageVisitsEntitiesResultsNewVisitPopup &&
              _vm.showManageVisitsEntitiesResultsPopup
                ? _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { staticClass: "mt-4", attrs: { cols: 12 } },
                        [
                          _vm.showManageVisitsEntitiesResultsPopup
                            ? _c("ManageVisitsEntitiesResults", {
                                attrs: {
                                  data: _vm.resultsData,
                                  entity: this.inputs.entity.value
                                },
                                on: {
                                  delete: function($event) {
                                    _vm.refreshResults()
                                  }
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showManageVisitsEntitiesResultsNewVisitPopup
                ? _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { staticClass: "mt-4", attrs: { cols: 12 } },
                        [
                          _c("ManageVisitsEntitiesResultsNew", {
                            on: {
                              closed: function($event) {
                                _vm.showManageVisitsEntitiesResultsNewVisitPopup = false
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Layout/CommercialManagement/ManageVisitsEntities.vue?vue&type=template&id=3caa1e4a&
// module id = null
// module chunks = 